import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72918683"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-tit" }, "图片", -1))
const _hoisted_3 = { class: "img-item" }

import { projectItem, staffItem } from '@/apis/base'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const visitDeatails = ref({
  created_at: '', // 创建时间
  address: '', // 详细地址
  district: '', // 地区
  person: '', // 拜访人员
  date: '', // 拜访时间
  content: '--', // 谈话内容
  pics: null,
  project: {} as projectItem,
  staff: {} as staffItem
})
const showBottom = ref(false)

const StaffInfo = ref({
  currentTime: '--', // 当前时间
  company_froms: {
    cf_name: '--'
  },
  name: '--'
})
onMounted(() => {
  visitDeatails.value = JSON.parse(router.currentRoute.value.query.data.toString())
  StaffInfo.value.currentTime = visitDeatails.value.created_at
  StaffInfo.value.name = visitDeatails.value.staff.name
  StaffInfo.value.company_froms.cf_name = visitDeatails.value.staff.cf_name

  let botton: any = router.currentRoute.value.query.button
  showBottom.value = botton
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_PreviewPicture = _resolveComponent("PreviewPicture")!
  const _component_common_info = _resolveComponent("common-info")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell, {
          title: "项目名称",
          value: visitDeatails.value.project.name
        }, null, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(_component_van_cell_group, { title: "拜访情况" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell, {
          title: "拜访时间",
          value: visitDeatails.value.date
        }, null, 8, ["value"]),
        _createVNode(_component_van_cell, {
          title: "拜访人员",
          value: visitDeatails.value.person
        }, null, 8, ["value"]),
        _createVNode(_component_van_cell, {
          title: "所在地区",
          value: visitDeatails.value.district
        }, null, 8, ["value"]),
        _createVNode(_component_van_cell, {
          title: "详细地址",
          value: visitDeatails.value.address
        }, null, 8, ["value"]),
        _createVNode(_component_van_cell, {
          class: "content",
          title: "谈话内容",
          value: visitDeatails.value.content
        }, null, 8, ["value"])
      ]),
      _: 1
    }),
    (visitDeatails.value.pics)
      ? (_openBlock(), _createBlock(_component_van_cell, {
          key: 0,
          class: "content",
          border: false
        }, {
          title: _withCtx(() => [
            _hoisted_2
          ]),
          value: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_PreviewPicture, {
                imgs: visitDeatails.value.pics,
                radius: 5,
                width: 65,
                height: 65
              }, null, 8, ["imgs"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_common_info, { StaffInfo: StaffInfo.value }, null, 8, ["StaffInfo"])
  ]))
}
}

})